(function () {
  if (window.__ssAnimations) return;
  window.__ssAnimations = true;

  const STAGGER = 120;
  // Plafond du décalage cumulé. Sans lui, une grille de 24 cartes finissait
  // à 2,8 s d'attente sur la dernière : l'effet ne se lit plus, il se subit.
  const MAX_DELAY = 300;
  let lastY = window.scrollY;
  let dir = 'down';

  window.addEventListener('scroll', () => {
    dir = window.scrollY > lastY ? 'down' : 'up';
    lastY = window.scrollY;
  }, { passive: true });

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      // data-ss-delay : délai imposé, tel quel.
      // data-ss-stagger : pas propre à l'élément (les cartes produit en
      // utilisent un plus court que le reste du site).
      const custom = el.dataset.ssDelay;
      const step = parseInt(el.dataset.ssStagger, 10) || STAGGER;
      const delay = custom !== undefined
        ? parseInt(custom, 10)
        : Math.min((parseInt(el.dataset.ssIndex, 10) || 0) * step, MAX_DELAY);

      if (entry.isIntersecting) {
        el.style.transitionDelay = delay + 'ms';
        el.classList.add('is-revealed');
      } else if (entry.boundingClientRect.top > 0 && dir === 'up') {
        el.style.transitionDelay = '0ms';
        el.classList.remove('is-revealed');
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

  function scan(root) {
    (root || document).querySelectorAll('.ss-anim').forEach((el, i) => {
      if (el.dataset.ssObserved) return;
      el.dataset.ssObserved = '1';
      if (!el.dataset.ssIndex && el.dataset.ssDelay === undefined) el.dataset.ssIndex = i;
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Horizon : page transitions + bfcache
  window.addEventListener('pageshow', (e) => { if (e.persisted) scan(); });
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
  document.addEventListener('shopify:block:select', (e) => scan(e.target));
  window.ssScanAnimations = scan;
})();